import { EntityType } from './entity-model';

export type EntityDetailsModalData = {
  entityId: string;
  canModify: boolean;
  canAbort: boolean;
  canDelete: boolean;
};

export const EntityTypeToDetailsModalName: Record<EntityType, string> = {
  run: 'RUN_DETAILS_MODAL_NAME',
  project: 'PROJECT_DETAILS_MODAL_NAME',
};
